import React from 'react';
import Header from './Header';
import './LayoutAdsup.css';

const LayoutAdsup = ({ children }) => {
    return (
        <div className="layout-adsup">
            <div className="layout-adsup-main">
                <Header />
                <main className="layout-adsup-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default LayoutAdsup;
